import { isEmpty } from 'lodash'
import React from 'react'

const processedMails = (mails) => {
  if (mails.length <= 2) return mails
  const sliceMails = mails.slice(0, 2)
  sliceMails.push('...')
  return sliceMails
}
const MailToColumnFramework = ({ value }) => {
  const mails = isEmpty(value) ? [] : processedMails(value)

  return (
    <div className='mailto-column'>
      <div className='flex-wrap'>
        {mails.map((mail, i) => (
          <p key={i}>{mail}</p>
        ))}
      </div>
    </div>
  )
}

export default MailToColumnFramework
